import { FormikTrackingField as TrackingField } from '@commons/components/Form/HiddenField';

/**
 * Type definition for the values in the form.
 */

export type TrackingFieldsValues = {
  node_id: string;
  url_source: string;
  form_type: string;
  utm_campaign: string;
  utm_content: string;
  utm_medium: string;
  utm_source: string;
  utm_term: string;
  google_click_id: string;
  facebook_click_id: string;
  linkedin_click_pid: string;
  linkedin_click_fat_id: string;
  linkedin_click_at: string;
  linkedin_click_trackclk: string;
  leadsource: string;
  leadsubsource: string;
  language?: string;
  asset_source?: string;
  consent_type?: string;
  consent_source?: string;
  consent_date?: string;
  drupal_token?: string;
};

/**
 * Initial values for each field in the form.
 */

export const TRACKING_FIELDS_INITIAL_VALUES: TrackingFieldsValues = {
  node_id: '',
  url_source: '',
  form_type: '',
  utm_campaign: '',
  utm_content: '',
  utm_medium: '',
  utm_source: '',
  utm_term: '',
  google_click_id: '',
  facebook_click_id: '',
  linkedin_click_pid: '',
  linkedin_click_fat_id: '',
  linkedin_click_at: '',
  linkedin_click_trackclk: '',
  leadsource: '',
  leadsubsource: '',
  language: '',
  asset_source: '',
  consent_type: '',
  consent_source: '',
  consent_date: '',
  drupal_token: '',
};

// Tracking Fields form values.

type FieldValues = {
  formType?: string;
};

/**
 * TrackingFields form component.
 */

const TrackingFields = ({ formType }: FieldValues) => (
  <>
    <TrackingField name="node_id" id="node_id" />
    <TrackingField name="url_source" id="url_source" />
    <TrackingField name="form_type" value={formType} id="form_type" />
    <TrackingField name="utm_campaign" id="utm_campaign" />
    <TrackingField name="utm_content" id="utm_content" />
    <TrackingField name="utm_medium" id="utm_medium" />
    <TrackingField name="utm_source" id="utm_source" />
    <TrackingField name="utm_term" id="utm_term" />
    <TrackingField name="gclid" id="gclid" />
    <TrackingField name="fbclid" id="fbclid" />
    <TrackingField name="pid" id="pid" />
    <TrackingField name="li_fat_id" id="li_fat_id" />
    <TrackingField name="li_at" id="li_at" />
    <TrackingField name="trackclk" id="trackclk" />
    <TrackingField name="leadsource" id="leadsource" />
    <TrackingField name="leadsubsource" id="leadsubsource" />
    <TrackingField name="pardot_visitor_id" id="pardot_visitor_id" />
    <TrackingField name="language" id="language" />
    <TrackingField name="asset_source" id="asset_source" />
    <TrackingField name="consent_type" id="consent_type" />
    <TrackingField name="consent_source" id="consent_source" />
    <TrackingField name="consent_date" id="consent_date" />
    <TrackingField name="drupal_token" id="drupal_token" />
  </>
);

export default TrackingFields;
